module.exports = __webpack_public_path__ + "static/media/left_arrow.0b9f4a5a.svg";